<script setup lang="ts">
import { computed } from 'vue';
import { PhSpinner } from '@phosphor-icons/vue';
import { loadingIcon } from './LoadingIconStyles';
// @ts-expect-error JSON module import handled by bundler
import lightTokens from '../../../../design-tokens/theme/tokens/light.tokens.json';

const props = defineProps<{
  color?: string;
  size?: 'small' | 'medium' | 'large' | number;
}>();

const defaultColor = lightTokens.color.content.onNegative;
const resolvedColor = computed(() => props.color ?? defaultColor);
</script>

<template>
  <PhSpinner
    :class="loadingIcon"
    :style="{ color: resolvedColor }"
    :size="16"
    weight="bold"
    aria-hidden="true"
  />
</template>
